<script setup>
import {
    formataCpf,
    formataDataFromDb,
    formataMoedaReais
} from '@kodatec/brasil-utils';

defineProps({
    solicitacao: {
        type: Object,
        required: true
    }
})
</script>

<template>
    <h3 class="text-900 font-bold text-sm mb-3 col-12">Dados da Solicitação</h3>

    <LabelDados titulo="Beneficiário" :conteudo="solicitacao.dados.pessoa_fisica_nome"
        :detalhe="`CPF: ${formataCpf(solicitacao.dados.pessoa_fisica_cpf, false)}`" />

    <LabelDados titulo="Valor" :conteudo="formataMoedaReais(solicitacao.dados.valor)" />

    <LabelDados titulo="Justificativa" :conteudo="solicitacao.dados.justificativa" tamanho_div="col-12" />

    <hr class="w-full border-solid border-top-1 border-bottom-none surface-border my-3"
        v-if="solicitacao.dados.tem_boleto">

    <h3 class="text-900 font-bold text-sm mb-3 col-12" v-if="solicitacao.dados.tem_boleto">Informações do Boleto</h3>

    <LabelDados v-if="solicitacao.dados.tem_boleto" titulo="Valor"
        :conteudo="`${formataMoedaReais(solicitacao.dados.boleto_valor)} - Data de vencimento: ${formataDataFromDb(solicitacao.dados.boleto_data_vencimento)}`"
        detalhe="Esta solicitação será paga via boleto bancário" tamanho_div="col-12" />
</template>